export const BUTTON_LABEL: Record<string, string> = {
  a: 'A',
  b: 'B',
  x: 'X',
  y: 'Y',
  up: 'Up',
  down: 'Down',
  right: 'Right',
  left: 'Left',
  r1: 'R1',
  r2: 'R2',
  r4: 'R4',
  l1: 'L1',
  l2: 'L2',
  l4: 'L4',
};
